import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { DrugPlan } from '../../../../models/drug-plan'
import { PlanList } from '../../../../models/plan-list'
import { Notes } from '../../../../models/notes'
import { EnrollmentElectionType } from '../../../../models/enrollment-election-type'
import { Step4Model } from '../../../../models/Step4Model'
import { DataEntryStep1 } from '../../../../models/data-entry-step1'
import { BeneficiaryInfo } from '../../../../models/enrollments'
import { EnrollmentViewModel } from '../../../../models/enrollment-view-model'
import { EnrollmentGateway } from '../../../../gateways/enrollment-gateway'
import { SubmitEnrollmentDataResponse } from '../../../../models/submit-enrollment-data-response'
import { PortalGlobals } from '../../../../../portalglobals'
import * as moment from 'moment'

@Component({
    selector: 'PhoneEnrollmentSpanishPreview',
    templateUrl: 'phone-enrollment-preview.component.html'
})
export class PhoneEnrollmentSpanishPreviewComponent implements OnInit {
    drugPlanModel = {} as DrugPlan
    notesModel = {} as Notes
    planList = [] as PlanList[]
    enrollmentElectionTypes: EnrollmentElectionType[] = [new EnrollmentElectionType()]
    paymentMethod: BeneficiaryInfo
    step4Model: Step4Model
    step1Model: DataEntryStep1
    enrollment: EnrollmentViewModel = {} as EnrollmentViewModel
    AccountName: string
    AccountType: string | null
    AgentName: string
    DataEntryAgentName: string
    hasError: boolean
    ErrorMessages: any[]
    userPofilename: string
    agentID: string
    appDate: string
    effDate: string
    dob: string
    medAdate: string
    medBDate: string
    sepEffDate: string
    eob: string
    accessible: string
    showSepEffDate: boolean
    visibleFrom2025: boolean

    constructor(private router: Router, private _enrollementGateway: EnrollmentGateway, private _portalGlobal: PortalGlobals) {
        this.step4Model = {} as Step4Model
        this.step4Model.notes = {} as Notes
        this.step4Model.prescriptionDrug = {} as DrugPlan
        this.paymentMethod = {} as BeneficiaryInfo
        this.ErrorMessages = [] as any[]
    }

    ngOnInit() {
        this.agentID = this._portalGlobal.currentUser.userProfileName
        this.enrollment = this._enrollementGateway.getEnrollmentViewModel()
        this.appDate = this.enrollment.APPDT == undefined ? '' : moment(this.enrollment.APPDT, 'MM/DD/YYYY', true).format('MM/DD/YYYY')
        this.effDate = this.enrollment.EFFDT == undefined ? '' : moment(this.enrollment.EFFDT, 'MM/DD/YYYY', true).format('MM/DD/YYYY')
        this.dob = this.enrollment.APPDOB == undefined ? '' : moment(this.enrollment.APPDOB, 'MM/DD/YYYY', true).format('MM/DD/YYYY')
        this.medAdate = this.enrollment.MEDA == undefined ? '' : moment(this.enrollment.MEDA, 'MM/DD/YYYY', true).format('MM/DD/YYYY')
        this.medBDate = this.enrollment.MEDB == undefined ? '' : moment(this.enrollment.MEDB, 'MM/DD/YYYY', true).format('MM/DD/YYYY')
        this.sepEffDate = this.enrollment.SEPEFFDT == undefined ? '' : moment(this.enrollment.SEPEFFDT, 'MM/DD/YYYY', true).format('MM/DD/YYYY')
        this.showSepEffDate = this.enrollment.SEPEFFDT == undefined ? false : true
        this.userPofilename = this._portalGlobal.currentUser.userProfileName
        if (this._portalGlobal.selectedPlanYear > this._portalGlobal.Planyear2024) {
            this.visibleFrom2025 = true
        } else {
            this.visibleFrom2025 = false
        }
        if (this.enrollment !== undefined) {
            if (this.enrollment.EFTTYPE === 'S') {
                this.AccountType = 'Savings'
            } else if (this.enrollment.EFTTYPE === 'C') {
                this.AccountType = 'Checking'
            } else {
                this.AccountType = this.enrollment.EFTTYPE
            }
            //if (this.enrollment.EOB === 'EEOB') {
            if (
                this.enrollment.EOB === '3' ||
                this.enrollment.EOB === 'EEOB' ||
                this.enrollment.EOB === '5' ||
                this.enrollment.EOB === '6' ||
                this.enrollment.EOB === '7' ||
                this.enrollment.EOB === '9'
            ) {
                this.eob = 'Yes'
            } else {
                this.eob = 'No'
            }

            if (this.enrollment.EOB === '1' || this.enrollment.EOB === '5') {
                this.accessible = 'Large Print'
            } else if (this.enrollment.EOB === '2' || this.enrollment.EOB === '6') {
                this.accessible = 'Braille'
            } else if (this.enrollment.EOB === '4' || this.enrollment.EOB === '7') {
                this.accessible = 'Audio CD'
            } else if (this.enrollment.EOB === '8' || this.enrollment.EOB === '9') {
                this.accessible = 'Data CD'
            } else {
                this.accessible = ''
            }
            // get Agent Name in Agent ID & Data Entry ID
            this.AgentName = this.enrollment.AGENTID
            this.DataEntryAgentName = String(this.enrollment.ADMINID)
            //check for EOB.
        }
        // alert(this.paymentMethod.lastName)
    }
    formSubmit(): void {
        this.enrollment.STEPCODE = '6'
        this.enrollment.SUBMISSIONTYPECODE = 'COMPLETE'
        this._enrollementGateway.setEnrollmentViewModel(this.enrollment)
        const insCo = this._portalGlobal.currentUser.insuranceCompanyShortName.toLowerCase()

        this._enrollementGateway.UpdateEnrollmentData(this.enrollment).subscribe((model: SubmitEnrollmentDataResponse) => {
            let response = model
            if (response !== undefined) {
                if (response.Errors !== undefined && response.Errors.length > 0) {
                    this.hasError = false

                    for (let i = 0; i < response.Errors.length; i++) {
                        this.ErrorMessages.push(response.Errors[i].ErrorMessage)
                    }
                    window.scrollTo(0, 0)
                } else {
                    this.enrollment.CONF = response.confirmationNumber
                    this._enrollementGateway.setEnrollmentViewModel(this.enrollment)

                    this.updateDataServiceCall('/' + insCo + '/enrollment/phone-enrollment/spanish/Final')
                }
            } else {
                this.ErrorMessages.push('Error while submitting data, please try again.')
                window.scrollTo(0, 0)
            }
        })
    }

    goBack(): void {
        const insCo = this._portalGlobal.currentUser.insuranceCompanyShortName.toLowerCase()
        this.router.navigate(['/' + insCo + '/enrollment/phone-enrollment/spanish/Step5'])
    }

    updateDataServiceCall(route: string) {
        this.router.navigate([route])
    }
    keyDownFunction(event) {
        const ENTER_KEY = 13
        if (event.keyCode === ENTER_KEY) {
            this.formSubmit()
        }
    }
}
